import { useBalanceChecker } from "app/components/common";
import { COPY } from "app/constants";
import {
    LendingVaultExpanded,
    summarizeVaultSuppliedDeposits,
    useUserGenesisWhitelisted
} from "@bridgesplit/abf-react";

import { useVaultDepositContext } from "./VaultDepositContext";
import { useVaultContext } from "../VaultContext";

export function useVaultDepositBalance() {
    const { form } = useVaultDepositContext();
    const { vaultExpanded } = useVaultContext();

    return useBalanceChecker({
        amount: form.amount,
        mint: vaultExpanded?.principalMetadata?.mint
    });
}

export function useDepositUpdateAmount() {
    const { setForm } = useVaultDepositContext();
    return (amount: number | undefined) => setForm((prev) => ({ ...prev, amount }));
}

export function useGenesisVaultDepositButtonText(vaultExpanded: LendingVaultExpanded | undefined) {
    const { isUserGenesisWhitelisted } = useUserGenesisWhitelisted();
    const { supplyLimitReached } = summarizeVaultSuppliedDeposits(vaultExpanded);

    if (!isUserGenesisWhitelisted) {
        return COPY.GENESIS_VAULT_COMING_SOON;
    }

    if (supplyLimitReached) {
        return COPY.SUPPLY_LIMIT_REACHED;
    }

    return COPY.VAULT_DEPOSIT_CTA;
}
